<template>
  <div>
    <main class="container-fluid">
      <section class="row">
        <div class="col-4 px-3 py-3"></div>
        <div
          class=" col-md-16 px-md-3 py-md-3 pt-3 pt-md-0 px-3 px-md-0 mb-md-5"
        >
          <div class="col d-column">
            <h1 class="title pt-2 mb-0" v-text="$ml.get('dashNdaTitle')"></h1>
            <h1 class="title">
              <span v-text="$ml.get('dashNdaSubTitle')" class="pb-2"></span>
            </h1>

            <div class="card mb-3">
              <div class="card-header">
                <span v-text="$ml.get('signedAgreements')" class="pb-2"></span>
              </div>
              <div class="card-body" v-if="!program_list.length">
                <h6 class="my-1" v-text="$ml.get('youDontHaveAnyNDAsHacker')">
                  Você ainda não concordou com nenhum contrato de
                  confidencialidade!
                </h6>
              </div>
              <div v-for="(item, index) in program_list" :key="index" v-else>
                <div class="card-body">
                  <div class="d-column flex-row">
                    <div
                      class="h-profile h-profile-lg d-flex flex-column pb-3 align-items-center no"
                    >
                      <div class="d-flex w-100">
                        <div
                          class="pl-2 d-flex flex-row w-100 justify-content-between align-center"
                        >
                          <b-row class="text-center" align-v="center">
                            <div>
                              <object
                                width="48"
                                height="48"
                                class="rounded-circle img-lg mr-3"
                                :data="item.avatar"
                                type="image/png"
                              >
                                <img
                                  width="48"
                                  height="48"
                                  class="rounded-circle img-lg mr-3"
                                  src="../../../assets/images/default.png"
                                  alt="Avatar"
                                />
                              </object>
                            </div>
                            <div>
                              <h3>
                                <a class="link-block"
                                  ><strong v-text="item.name"></strong
                                ></a>
                              </h3>
                            </div>
                          </b-row>
                          <b-row
                            align-v="center"
                            class="actions mt-2 d-flex flex-row"
                          >
                            <b-button
                              class="nda-icon-button mr-2 bg-light"
                              @click="loadNda(item._id,'showModal')"
                            >
                              <span class="ico-btn">
                                <img
                                  class="img-ico-btn ml-2"
                                  src="../../../assets/icons/eye.svg"
                                />
                              </span>
                            </b-button>
                            <b-button
                              class="nda-icon-button bg-light"
                              @click="loadNda(item._id,'downloadPdf')"
                            >
                              <span class="ico-btn">
                                <img
                                  class="img-ico-btn ml-2"
                                  src="../../../assets/icons/download.svg"
                                />
                              </span>
                            </b-button>
                          </b-row>
                        </div>
                      </div>

                      <div class="d-flex align-self-start h-profile">
                        <div class="v-line d-flex align-items-stretch">
                          <span class="pb-4"></span>
                        </div>
                      </div>

                      <div class="d-flex align-self-start h-profile-circle">
                        <div class="circle d-flex justify-content-center">
                          <span
                            class="circle-internal d-flex justify-content-center"
                            ><span class="circle-success"></span
                          ></span>
                          <div class="h-line"><span></span></div>
                        </div>
                        <div class="pl-3 d-flex w-100 align-items-center">
                          <div
                            class="d-flex flex-row justify-content-between align-items-start w-100"
                          >
                            <p class="d-flex align-items-center">
                              <label class="mr-1"
                                >Você assinou o NDA do programa <b>{{item.name}}</b> há
                              </label>
                              <label
                                v-text="
                                  $utils.formatData(
                                    item.program_nda_createdAt,
                                    $ml.get('ln')
                                  ) + '.'
                                "
                              ></label>
                            </p>
                            <p class="time">
                                                            <label
                                v-text="
                                  $utils.formatDataLong(
                                    item.program_nda_createdAt,
                                    $ml.get('ln')
                                  )
                                "
                              ></label>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <b-modal
            id="modal-nda"
            class="my-modal"
            data-bs-keyboard="false"
            hide-header
            hide-footer
            size="xl"
          >
            <b-container
              fluid="xl"
              style="max-height: 80vh !important; overflow-y: auto !important;"
            >
              <div class="col modal-body">
                <div v-show="htmlText" v-html="htmlText" class="m-4"></div>
              </div>
            </b-container>
          </b-modal>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import ProgramService from "../../../services/program.service";

export default {
  name: "Nda",

  data() {
    return {
      ndaMaxLengt: false,
      nda: "",
      programId: "",
      htmlText: "",
      errorNda: false,
      loadingBtn: false,
      loading: false,
      program_list: [],
      name: "",
      company_name: "",
    };
  },
  mounted() {
    this.loadNdaList();
  },
  methods: {
    controlTextArea() {
      const { textarea } = this.$refs;
      textarea.style.height =
        textarea.scrollHeight < 800 ? textarea.scrollHeight + "px" : 800 + "px";
      this.nda = textarea.value;
      if (textarea.value.length > 300000) {
        this.nda = textarea.value.substring(0, 300000);
        this.ndaMaxLengt = true;
      } else {
        this.ndaMaxLengt = false;
      }
    },
    printDiv() {
      let mywindow = window.open(
        "",
        "PRINT",
        "height=650,width=900,top=100,left=150"
      );

      mywindow.document.write("</head><body >");
      mywindow.document.write(this.htmlText);
      mywindow.document.write("</body></html>");

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      mywindow.print();
      mywindow.close();

      return true;
    },
    async loadNda(programId, param) {
      this.htmlText = "";
      ProgramService.getNda(programId).then(
        (response) => {
          if (response.data.description) {
            this.nda = response.data.description;
            this.name = response.data.name;
            this.company_name = response.data.company_name;
            this.htmlText = "";
            this.htmlText = this.$utils.convertMarkedOld(
              this.nda,
              [],
              this.company_name,
              this.name
            );

            if (param == "downloadPdf") {
              this.printDiv();
            } else if (param == "showModal") {
              this.$bvModal.show("modal-nda");
            }
          }
        },
        () => {
          this.loadingBtn = false;
          Swal.fire({
            icon: "info",
            title: self.$ml.get("unableToCompleteThisRequest"),
            showConfirmButton: false,
            timer: 3000,
          });
        }
      );
    },
    async loadNdaList() {
      this.loading = true;
      ProgramService.getNdaList().then(
        (response) => {
          if (response.data) {
            this.program_list = response.data;
          }
          this.loading = false;
        },
        () => {
          this.loadingBtn = false;
          Swal.fire({
            icon: "info",
            title: self.$ml.get("unableToCompleteThisRequest"),
            showConfirmButton: false,
            timer: 3000,
          });
          this.loading = false;
        }
      );
    },
  },
};
</script>

<style scoped>
.primary-text {
  color: #730ba9 !important;
}
.nda-icon-button {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center !important;
  align-content: center !important;
  align-items: center !important;
  border-radius: 5px;
}
.ico-btn {
  width: auto;
  height: auto;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  border-radius: 5px;
}
.img-ico-btn {
  width: 30px;
  height: 20px;
  align-self: center;
}
</style>
